import React from 'react'
import { Loading } from '@myxplor/ui'
import LocalAsyncStore from '../../../../../local-async-store'
import { hasAvailableAction } from '../../../../../ui/gov-actions'
import './check-device-status.css'

const available = record => hasAvailableAction(record, 'check_device_credentials')

const apiEndPoint = ({ gov_id }) => `/api/service-registrations/${gov_id}/check-device-credentials`

const CheckDeviceCredentialsInfo = ({ credentials_response }) => {
  if (credentials_response.loading) {
    return <Loading>Checking device...</Loading>
  }

  if (credentials_response.errors[0]) {
    return <div className="checkDeviceCredentials--error">{credentials_response.errors[0]}</div>
  }

  return credentials_response.success ? <div>{credentials_response.data.response}</div> : null
}

const CheckDeviceCredentialsFetch = record =>
  LocalAsyncStore('credentials_response', CheckDeviceCredentialsInfo, () => apiEndPoint(record))

const checkDeviceCredentials = ({ record }) =>
  available(record)
    ? {
        label: 'Check Device Credentials',
        value: 'check_device_credentials',
        actionForm: CheckDeviceCredentialsFetch(record),
      }
    : null

export default checkDeviceCredentials



// WEBPACK FOOTER //
// ./src/gov-registrations/details/ccs-registrations/actions/check-device-credentials/index.js